import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight } from 'lucide-react';

const HERO_BG = 'https://images.unsplash.com/photo-1548945665-56d2712b4986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxzdGFpbmxlc3MlMjBzdGVlbCUyMHdlbGRpbmd8ZW58MHx8fHwxNzc1NTAyNzM3fDA&ixlib=rb-4.1.0&q=85';

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Industrial welding"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#003865]/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full pt-20">
        <div className="max-w-4xl">
          {/* Overline */}
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-px bg-white/50" />
            <span
              className="text-xs font-bold uppercase tracking-[0.25em] text-white/70"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              AFRICAINOX
            </span>
          </div>

          {/* Main headline */}
          <h1
            data-testid="hero-tagline"
            className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-[1.05] tracking-tight mb-6"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            {t('hero.tagline')}
            <br />
            <span className="text-white/80">{t('hero.tagline2')}</span>
          </h1>

          {/* Subtitle */}
          <p
            data-testid="hero-subtitle"
            className="text-lg sm:text-xl text-white/60 max-w-2xl mb-12"
            style={{ fontFamily: 'Roboto, sans-serif' }}
          >
            {t('hero.subtitle')}
          </p>

          {/* CTA */}
          <button
            data-testid="hero-cta"
            onClick={() => {
              const el = document.querySelector('#services');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="group bg-white text-[#003865] px-8 py-4 font-semibold uppercase tracking-wide text-sm flex items-center gap-3 hover:bg-white/90 transition-colors duration-200"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            {t('hero.cta')}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-200" />
          </button>
        </div>
      </div>

      {/* Bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-white/10" />
    </section>
  );
}
